(function(){
  function init(root){
    if(root.__wlHeroBound)return;
    root.__wlHeroBound=true;
    var slides=root.querySelectorAll('.wl-hero-slide');
    var dots=root.querySelectorAll('.wl-hero-dot');
    if(slides.length<2)return;
    var i=0,delay=parseInt(root.getAttribute('data-wl-interval'),10)||5000,timer;
    function hydrate(slide){
      if(!slide||!slide.hasAttribute('data-wl-defer'))return;
      slide.removeAttribute('data-wl-defer');
      [].forEach.call(slide.querySelectorAll('[data-srcset],[data-src]'),function(el){
        var ss=el.getAttribute('data-srcset'),s=el.getAttribute('data-src');
        if(ss){el.setAttribute('srcset',ss);el.removeAttribute('data-srcset');}
        if(s){el.setAttribute('src',s);el.removeAttribute('data-src');}
        if(el.tagName==='IMG')el.loading='eager';
      });
    }
    function warmAll(){[].forEach.call(slides,hydrate);}
    function imgOf(s){return s&&s.querySelector('img');}
    function isReady(s){var im=imgOf(s);return !im||(im.complete&&im.naturalWidth>0);}
    function whenReady(s,cb){
      hydrate(s);
      var im=imgOf(s);
      if(!im||isReady(s)){cb();return;}
      var done=false;
      function fire(){if(done)return;done=true;cb();}
      im.addEventListener('load',fire,{once:true});
      im.addEventListener('error',fire,{once:true});
    }
    var first=imgOf(slides[0]);
    if(!first||isReady(slides[0]))warmAll();
    else{first.addEventListener('load',warmAll,{once:true});first.addEventListener('error',warmAll,{once:true});}
    function show(n){
      slides[i].classList.remove('is-active');
      if(dots[i])dots[i].classList.remove('is-active');
      i=n;
      hydrate(slides[(i+1)%slides.length]);
      slides[i].classList.add('is-active');
      if(dots[i])dots[i].classList.add('is-active');
    }
    // Never reveal a slide before its image has loaded — wait for it instead of showing a blank frame.
    var pending=0;
    function go(n){
      var target=(n+slides.length)%slides.length,token=++pending;
      whenReady(slides[target],function(){if(token===pending&&target!==i)show(target);});
    }
    function start(){timer=setInterval(function(){go(i+1);},delay);}
    function restart(){clearInterval(timer);start();}
    dots.forEach(function(d,idx){d.addEventListener('click',function(){clearInterval(timer);go(idx);start();});});
    var sx=0,sy=0,dx=0,dy=0,dragging=false,decided=false;
    var SWIPE_MIN=40,DECIDE_MIN=8;
    root.addEventListener('touchstart',function(e){
      if(e.touches.length!==1){dragging=false;return;}
      sx=e.touches[0].clientX;sy=e.touches[0].clientY;
      dx=0;dy=0;dragging=true;decided=false;
    },{passive:true});
    root.addEventListener('touchmove',function(e){
      if(!dragging||e.touches.length!==1)return;
      dx=e.touches[0].clientX-sx;
      dy=e.touches[0].clientY-sy;
      if(!decided){
        if(Math.abs(dx)<DECIDE_MIN&&Math.abs(dy)<DECIDE_MIN)return;
        decided=true;
        if(Math.abs(dy)>Math.abs(dx)){dragging=false;return;}
      }
      e.preventDefault();
    },{passive:false});
    root.addEventListener('touchend',function(){
      if(!dragging)return;
      dragging=false;
      if(Math.abs(dx)>=SWIPE_MIN&&Math.abs(dx)>Math.abs(dy)){
        go(dx<0?i+1:i-1);
        restart();
      }
    },{passive:true});
    root.addEventListener('touchcancel',function(){dragging=false;},{passive:true});
    start();
  }
  function boot(){[].forEach.call(document.querySelectorAll('[data-wl-hero]'),init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);
  else boot();
})();